import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const Language = ({ data }) => {
    const navigate = useNavigate();
    const { request } = useParams();


    const [selectedLanguage, setSelectedLanguage] = useState(data?.selected_language);

    useEffect(() => {
        setSelectedLanguage(data?.selected_language)
    }, [data?.selected_language])
    return (
        <div className="px-4">
            <div
                className="card p-2 ps-4 mb-4 mt-4"
                style={{ backgroundColor: "#f8f8f8", border: "0.5px solid #f2f2f2" }}
            >
                <div className="fs-6">
                    Please select your preferred language from the below shared options
                </div>
            </div>

            <div className="card border rounded-4 p-0 mt-4 shadow-sm">
                <div className="card-body p-4">
                    <div className="mb-3">
                        <label className="form-label fw-semibold fs-5 text-dark text-center d-block">
                            Select Your Preferred Language
                            <span
                                className="d-block border-bottom border-3 mt-2 mx-auto"
                                style={{ width: "60px", borderColor: "#007bff" }}
                            ></span>
                        </label>

                        <div
                            className="d-flex flex-wrap justify-content-center gap-4 mt-3"
                            style={{ maxWidth: "360px", margin: "0 auto" }}
                        >
                            {data?.language?.map((name) => {
                                const isDisabled =
                                    data?.only_lang_selected !== 0 && data?.only_lang_selected !== name?.id;

                                return (
                                    <div
                                        key={name?.id}
                                        className={`border rounded-3 px-3 py-2 fw-semibold text-center transition 
                                        ${selectedLanguage === name?.id ? "bg-primary text-white" : "bg-light text-dark"} 
                                        ${isDisabled ? "opacity-50" : ""}`}
                                        onClick={() => !isDisabled && setSelectedLanguage(name?.id)}
                                        style={{
                                            cursor: isDisabled ? "not-allowed" : "pointer",
                                            width: "110px",
                                            transition: "all 0.3s ease-in-out",
                                            flex: "1 1 30%", // Ensures proper flex distribution
                                        }}
                                    >
                                        {name.name}
                                    </div>
                                );
                            })}

                        </div>
                    </div>

                    <button
                        className="btn btn-primary w-100 fw-semibold mt-3"
                        disabled={!selectedLanguage}
                        style={{ transition: "background 0.3s", opacity: selectedLanguage ? 1 : 0.6 }}
                        onClick={() => navigate(`/opted-in/${request}/${selectedLanguage}`)}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Language;
